import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const HealthcarePage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Healthcare | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Healthcare overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Healthcare</h1>
        <p>Welcome to the healthcare page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default HealthcarePage
